import React, { memo, useCallback } from 'react'

import { shape, string, bool, func, number } from 'prop-types'

function ImageSlide({ media, title, isFirstImage, loadLowQualityImage = false, onLoad, onError, slideIndex }) {
  const { model, imageName, alt, width, height } = media
  const { imageName: modelImageName } = model ?? {}
  const { url: fullscreenVariantUrl, large: largeVariant } = modelImageName ?? {}
  const { url: largeVariantUrl } = largeVariant ?? {}

  const fullScreenImageUrl = fullscreenVariantUrl || imageName
  const largeImageUrl = largeVariantUrl || imageName
  const imageUrl = (() => {
    if (loadLowQualityImage) {
      return largeImageUrl || imageName
    }

    return fullScreenImageUrl || largeVariantUrl
  })()

  const handleLoad = useCallback(() => {
    if (onLoad) {
      onLoad(slideIndex)
    }
  }, [onLoad, slideIndex])

  const handleError = useCallback(() => {
    if (onError) {
      onError(slideIndex)
    }
  }, [onError, slideIndex])

  // The slide is laid out as `height: 100%; width: auto`, so the browser derives the reserved
  // width from these attributes. A guessed pair reserves the wrong box and shifts on decode, so
  // emit them only when both intrinsic dimensions are known.
  const hasIntrinsicSize = width > 0 && height > 0

  return (
    <img
      alt={alt || title}
      className="gallery-area-top-carousel__image"
      src={imageUrl}
      loading={isFirstImage ? 'eager' : 'lazy'}
      fetchpriority={isFirstImage ? 'high' : 'auto'} // eslint-disable-line react/no-unknown-property
      decoding={isFirstImage ? 'sync' : 'async'}
      width={hasIntrinsicSize ? width : undefined}
      height={hasIntrinsicSize ? height : undefined}
      onLoad={handleLoad}
      onError={handleError}
    />
  )
}

ImageSlide.propTypes = {
  media: shape({
    model: shape({}),
    imageName: string,
    alt: string,
    width: number,
    height: number,
  }).isRequired,
  title: string.isRequired,
  isFirstImage: bool.isRequired,
  loadLowQualityImage: bool,
  onLoad: func,
  onError: func,
  slideIndex: number,
}

export default memo(ImageSlide)
